/* «Über uns»: Team-Karten per Tap (Touch), Team-Favoriten-Filter und
   Bildergalerie der Geschichte (Sean 29.09.2026). Hover auf Desktop macht
   das CSS allein. */
(function () {
  'use strict';

  function initTeam(root) {
    root.querySelectorAll('.dsab-team__member').forEach(function (m) {
      m.addEventListener('click', function () {
        var open = m.classList.contains('is-open');
        root.querySelectorAll('.dsab-team__member.is-open').forEach(function (o) { o.classList.remove('is-open'); });
        if (!open) m.classList.add('is-open');
      });
    });
  }

  var KEY = 'ds-about-fav';
  function initFav(root) {
    var pills = root.querySelectorAll('.dsab-fav__name');
    var panels = root.querySelectorAll('.dsab-fav__panel');
    var btn = root.querySelector('.dsab-fav__btn');
    if (!pills.length) return;
    function show(i, animate) {
      pills.forEach(function (p, j) { p.setAttribute('aria-pressed', j === i ? 'true' : 'false'); });
      panels.forEach(function (p, j) {
        p.hidden = j !== i;
        p.classList.remove('is-pop');
        if (j === i && animate) { void p.offsetWidth; p.classList.add('is-pop'); }
      });
      if (btn) {
        var pill = pills[i];
        btn.href = pill.dataset.url || btn.href;
        btn.textContent = (btn.dataset.label || '').replace('[name]', pill.textContent.trim());
      }
    }
    var start = 0;
    try { var s = parseInt(localStorage.getItem(KEY), 10); if (s >= 0 && s < pills.length) start = s; } catch (e) {}
    pills.forEach(function (p, i) {
      p.addEventListener('click', function () {
        show(i, true);
        try { localStorage.setItem(KEY, String(i)); } catch (e) {}
      });
    });
    show(start, false);
  }

  // Galerie der Geschichte: Pfeile, Tastatur, Wischen, Klick daneben schliesst.
  function initLightbox(root) {
    var dlg = root.querySelector('.dsab-lightbox');
    var items = root.querySelectorAll('button.dsab-story__item');
    if (!dlg || !items.length || typeof dlg.showModal !== 'function') return;
    var img = dlg.querySelector('.dsab-lightbox__img');
    var count = dlg.querySelector('.dsab-lightbox__count');
    var status = dlg.dataset.status || '';
    var cur = 0;
    function show(i) {
      cur = (i + items.length) % items.length;
      var src = items[cur].querySelector('img');
      img.src = items[cur].dataset.full;
      img.alt = src ? src.alt : '';
      count.textContent = status.replace('[i]', cur + 1).replace('[n]', items.length);
    }
    items.forEach(function (it, i) {
      it.addEventListener('click', function () { show(i); dlg.showModal(); });
    });
    dlg.querySelector('.dsab-lightbox__close').addEventListener('click', function () { dlg.close(); });
    dlg.querySelector('.dsab-lightbox__nav--prev').addEventListener('click', function () { show(cur - 1); });
    dlg.querySelector('.dsab-lightbox__nav--next').addEventListener('click', function () { show(cur + 1); });
    dlg.addEventListener('click', function (e) { if (e.target === dlg || e.target.classList.contains('dsab-lightbox__stage')) dlg.close(); });
    dlg.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') show(cur - 1);
      else if (e.key === 'ArrowRight') show(cur + 1);
    });
    var x0 = null;
    dlg.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
    dlg.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0;
      x0 = null;
      if (Math.abs(dx) > 40) show(cur + (dx < 0 ? 1 : -1));
    });
    dlg.addEventListener('close', function () { items[cur].focus(); });
  }

  // Team- und Favoriten-Sektion binden das Skript je selbst ein; jeder
  // Block wird trotzdem nur einmal initialisiert.
  function once(fn) {
    return function (root) {
      if (root.dataset.dsabInit) return;
      root.dataset.dsabInit = '1';
      fn(root);
    };
  }
  function init() {
    document.querySelectorAll('.dsab-team').forEach(once(initTeam));
    document.querySelectorAll('.dsab-fav').forEach(once(initFav));
    document.querySelectorAll('.dsab-story').forEach(once(initLightbox));
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
